import { jsxs as g, jsx as e } from "react/jsx-runtime";
import { Checkbox as N, ActionMenu as w } from "@systemeio/ui";
import n from "react";
import { FilePreview as C } from "../file-preview/index.mjs";
import { twMerge as c } from "tailwind-merge";
function B({
  fileType: p,
  src: u,
  alt: f,
  name: o,
  secondaryText: i,
  style: x,
  selected: s,
  actionMenu: t,
  className: d,
  imageWidth: h,
  imageHeight: v,
  onSelect: b
}) {
  const r = n.useRef(null), a = n.useRef(null);
  return /* @__PURE__ */ g(
    "div",
    {
      className: c("relative flex flex-col cursor-pointer", d),
      style: x,
      onClick: (l) => {
        var m;
        r.current && !((m = a.current) != null && m.contains(l.target)) && r.current.click();
      },
      children: [
        /* @__PURE__ */ e(
          C,
          {
            src: u ?? "",
            fileType: p,
            alt: f,
            width: h,
            height: v,
            className: c(
              "relative -top-[2px] -left-[2px] flex-1 rounded-lg border-2 border-transparent box-content",
              s && "border-brand-primary"
            ),
            isThumbnail: !0
          }
        ),
        /* @__PURE__ */ e("div", { ref: a, className: "absolute top-1 left-1", children: /* @__PURE__ */ e(N, { inputRef: r, value: s, onChange: b }) }),
        /* @__PURE__ */ e("div", { onClick: (l) => l.stopPropagation(), children: /* @__PURE__ */ e(
          w,
          {
            toggleOnHover: !0,
            menuButtonClassName: "absolute top-1 right-1 p-1 h-[20px] w-[26px]",
            menuItemsClassName: "z-30",
            ...t,
            menuItems: (t == null ? void 0 : t.menuItems) ?? []
          }
        ) }),
        /* @__PURE__ */ e(
          "div",
          {
            className: "truncate overflow-clip text-base text-text-primary mt-1",
            title: o,
            children: o
          }
        ),
        /* @__PURE__ */ e(
          "div",
          {
            className: "truncate overflow-clip text-sm text-text-secondary mt-1",
            title: i,
            children: i
          }
        )
      ]
    }
  );
}
export {
  B as FileItem
};
